/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class InstagramOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy="Select an Instagram Account"
                    serviceMessage={(
                        <span>
                            Instagram supports third-party publishing to Instagram Business and Creator accounts. <a href="https://support.dlvrit.com/hc/en-us/articles/1260803288509" target="_blank">Learn more</a>
                        </span>
                    )}/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={(
                        <p className="chooser-notice">You've already connected all your Instagram Professional accounts to dlvr.it</p>
                    )}
                    ineligibleMessage={(
                        <p className="chooser-notice">
                            Instagram Personal accounts are not eligible for posting. <a href="https://support.dlvrit.com/hc/en-us/articles/1260803288509" target="_blank">Learn more</a>
                        </p>
                    )}
                    typeLabel="profile"/>
            </div>
        );
    }
}

InstagramOutput.displayName = "InstagramOutput";

export default InstagramOutput;
